'use client';
import React from 'react';
export var CustomContext = /*#__PURE__*/React.createContext({});